/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Your_BookInputs */

const en_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your book...`)
};

const es_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando tu libro...`)
};

const fr_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de votre livre...`)
};

const de_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Buch wird geladen...`)
};

const ja_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本を読み込んでいます...`)
};

const zh_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载您的电子书...`)
};

const ar_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري تحميل كتابك...`)
};

const id_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat buku Anda...`)
};

const it_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del tuo libro...`)
};

const ru_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка вашей книги...`)
};

const pt_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o seu livro...`)
};

const ko_loading_your_book = /** @type {(inputs: Loading_Your_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`책을 불러오는 중...`)
};

/**
* | output |
* | --- |
* | "Loading your book..." |
*
* @param {Loading_Your_BookInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const loading_your_book = /** @type {((inputs?: Loading_Your_BookInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Your_BookInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_your_book(inputs)
	if (locale === "es") return es_loading_your_book(inputs)
	if (locale === "fr") return fr_loading_your_book(inputs)
	if (locale === "de") return de_loading_your_book(inputs)
	if (locale === "ja") return ja_loading_your_book(inputs)
	if (locale === "zh") return zh_loading_your_book(inputs)
	if (locale === "ar") return ar_loading_your_book(inputs)
	if (locale === "id") return id_loading_your_book(inputs)
	if (locale === "it") return it_loading_your_book(inputs)
	if (locale === "ru") return ru_loading_your_book(inputs)
	if (locale === "pt") return pt_loading_your_book(inputs)
	return ko_loading_your_book(inputs)
});